import axios from '../axios';
import api from '../api.mappings';
export class WechatApi {
    sign(params) {
        return axios.get(api.wechat.sign, {
            params
        });
    }
    login(params) {
        return axios.get(api.wechat.login, {
            params
        });
    }
    //  joychat 登录
    loginJoychat(params) {
        //  https://bpm.azure.bba-app.com
        return axios.get('/api/joyChat/sso/login', {
            params
        });
    }
    //  joychat 获取token
    getToken(params) {
        return axios.get(`/api/echop/mobile/getToken`, { params });
    }
}
